import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import { Profile } from "../settings/Profile";
import { matchPath } from "react-router-dom";
import AboutPage from "../about/pages/AboutPage";
import { LoginPage, MagicLinkPage, RegisterPage, } from "../auth/pages/AuthPages";
import ContactPage from "../contact/pages/ContactPage";
import { ConsultationDetailsPage } from "../consultations/pages/ConsultationDetailsPage";
import { ConsultationFormPage } from "../consultations/pages/ConsultationFormPage";
import { ConsultationsHomePage } from "../consultations/pages/ConsultationsHomePage";
import { OpenContributionPage } from "../consultations/pages/OpenContributionPage";
import { HearingDetailsPage } from "../hearings/pages/HearingDetailsPage";
import { HearingFormPage } from "../hearings/pages/HearingFormPage";
import { HearingOpenContributionPage } from "../hearings/pages/HearingOpenContributionPage";
import { NotFoundPage } from "./pages/RoutePlaceholders";
export var appRoutes = [
    {
        Component: ConsultationsHomePage,
        contentOnly: true,
        description: "Entrada principal da plataforma e futuro catalogo das consultas publicas.",
        icon: HomeRoundedIcon,
        navigationLabel: "Inicio",
        path: "/",
        showInNavigation: true,
        title: "Consultas publicas",
    },
    {
        Component: ConsultationDetailsPage,
        contentOnly: true,
        description: "Detalhamento de uma consulta identificado pelo slug.",
        path: "/details/:slug",
        title: "Detalhes da consulta",
    },
    {
        Component: HearingDetailsPage,
        contentOnly: true,
        description: "Detalhamento publico de uma audiencia.",
        path: "/hearings/details/:slug",
        title: "Detalhes da audiencia",
    },
    {
        Component: HearingFormPage,
        contentOnly: true,
        description: "Formulario dinamico de resposta para uma audiencia.",
        path: "/hearings/form/:id",
        title: "Formulario da audiencia",
    },
    {
        Component: HearingOpenContributionPage,
        contentOnly: true,
        description: "Contribuicao aberta e comentarios da audiencia.",
        path: "/hearings/contribution/:id",
        title: "Contribuicao aberta da audiencia",
    },
    {
        Component: ConsultationFormPage,
        contentOnly: true,
        description: "Formulario dinamico de resposta para uma consulta.",
        path: "/form/:id",
        title: "Formulario da consulta",
    },
    {
        Component: OpenContributionPage,
        contentOnly: true,
        description: "Fluxo de contribuicao aberta e comentarios da consulta.",
        path: "/contribution/:id",
        title: "Contribuicao aberta",
    },
    {
        Component: LoginPage,
        description: "Ponto de entrada para autenticacao do usuario.",
        layout: "auth",
        path: "/login",
        title: "Entrada Smartpass",
    },
    {
        Component: RegisterPage,
        description: "Cadastro e orientacao de acesso para o usuario.",
        layout: "auth",
        path: "/register",
        title: "Cadastro e acesso",
    },
    {
        Component: MagicLinkPage,
        description: "Retorno de autenticacao preservado do legado.",
        layout: "auth",
        path: "/auth/magic-link",
        title: "Retorno de autenticacao",
    },
    {
        Component: AboutPage,
        contentOnly: true,
        description: "Informacoes institucionais sobre a Plataforma ParticiPE.",
        navigationLabel: "Sobre",
        path: "/about",
        showInNavigation: true,
        title: "Sobre",
    },
    {
        Component: ContactPage,
        contentOnly: true,
        description: "Canais de contato da equipe responsavel pelo ParticiPE.",
        navigationLabel: "Contato",
        path: "/contact",
        showInNavigation: true,
        title: "Contato",
    },
    {
        Component: Profile,
        description: "Diagnostico do perfil local carregado a partir do Smartpass.",
        icon: PersonOutlineRoundedIcon,
        navigationLabel: "Meu perfil",
        path: "/profile",
        showInNavigation: true,
        title: "Meu perfil",
    },
    {
        Component: NotFoundPage,
        description: "Fallback para rotas nao registradas no SPA.",
        path: "*",
        title: "Pagina nao encontrada",
    },
];
export var getNavigationRoutes = function () {
    return appRoutes.filter(function (route) { return route.showInNavigation; });
};
export var getDefaultHomePath = function (role) {
    return "/";
};
export var resolveRouteDefinition = function (pathname) {
    var _a;
    return (_a = appRoutes.find(function (route) {
        if (route.path === "*") {
            return false;
        }
        return Boolean(matchPath({
            end: true,
            path: route.path,
        }, pathname));
    })) !== null && _a !== void 0 ? _a : appRoutes.find(function (route) { return route.path === "*"; });
};
